import type { JwtPayload } from '@borg/types';

export const useUser = () => useState<JwtPayload | null>('user', () => null);

export const useDomain = () => useState<string>('domain', () => '');
